import TripExpense from "./TripExpense";

export default TripExpense;
